import { createContext, useState, useEffect, ReactNode } from "react";
import en from "../locales/en.json";
import id from "../locales/id.json";

type LanguageStateType = {
  language: string;
  messages: Record<string, string>;
  changeLanguage: (lang: string) => void;
};

export const defaultLanguageState: LanguageStateType = {
  language: "EN",
  messages: en,
  changeLanguage: () => {},
};

const LanguageContext = createContext<LanguageStateType>(defaultLanguageState);

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<LanguageStateType>({
    language: "EN",
    messages: en,
    changeLanguage: (lang: string) => {
      const messages = lang.toUpperCase() === "EN" ? en : id;
      setState(prev => ({
        ...prev,
        language: lang.toUpperCase(),
        messages
      }));
      // Save to localStorage for persistence
      if (typeof window !== "undefined") {
        localStorage.setItem("language", lang.toUpperCase());
      }
    }
  });

  useEffect(() => {
    // Only run on client-side
    if (typeof window === "undefined") return;
    
    try {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        const messages = storedLanguage.toUpperCase() === "EN" ? en : id;
        setState(prev => ({
          ...prev,
          language: storedLanguage.toUpperCase(),
          messages
        }));
      }
    } catch (e) {
      console.error("Error loading language from localStorage:", e);
    }
  }, []);

  return (
    <LanguageContext.Provider value={state}>
      {children}
    </LanguageContext.Provider>
  );
}

export default LanguageContext;